import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import EmptyStateImage from './components/Image';

const EmptyDownloads = () => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'All your downloads, tracked and organized' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({ defaultMessage: 'See all your workspace downloads in one place. Filter by date, user, and more. Download some files to get started!' })}
        </div>
        <Button tag={Link} to="/files" color="primary" className="mt-4">
          {intl.formatMessage({ defaultMessage: 'Back to files' })}
        </Button>
      </Col>
      <EmptyStateImage imageUrl="/images/empty-pages/empty-downloads-page.png" height="high" />
    </div>
  );
};

export default EmptyDownloads;
